module.exports = __webpack_public_path__ + "static/media/tut-3.befe9e3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/tut-3.svg
// module id = 185
// module chunks = 0